export default __webpack_public_path__ + "static/media/Protest.ee61b94f.svg";